module.exports = __webpack_public_path__ + "img/logo-cea.9ce9572e.png";